import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "title", "link", "isDeepLink", "icon", "children", "onVisible"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { forwardRef, useEffect, useRef } from 'react';
import { combineRefs } from '@carnica/utils';
import { defineUrlIcon } from '@carnica/graphics';
import { Text } from '@carnica/ui-kit';
import { cnBem, useNodeObserver } from "../../../../shared/lib";
import styles from "./styles.pcss";
var cnQuickButton = cnBem('quick-button', styles);
export var QuickButton = /*#__PURE__*/forwardRef(function (props, ref) {
  var className = props.className,
    title = props.title,
    link = props.link,
    isDeepLink = props.isDeepLink,
    icon = props.icon,
    children = props.children,
    onVisible = props.onVisible,
    otherProps = _objectWithoutProperties(props, _excluded);
  var buttonRef = useRef(null);
  var isVisible = useNodeObserver({
    ref: buttonRef,
    callback: function callback(_ref) {
      var isIntersecting = _ref.isIntersecting;
      return isIntersecting;
    },
    options: {
      threshold: [0.75]
    }
  });
  var params = link !== null && link !== void 0 && link.trim() ? _objectSpread({
    href: link,
    target: 'self'
  }, otherProps) : otherProps;
  var Icon = typeof icon === 'string' ? defineUrlIcon({
    url: icon,
    ratio: 1
  }) : icon;
  var Tag = link !== null && link !== void 0 && link.trim() ? 'a' : 'button';
  useEffect(function () {
    onVisible === null || onVisible === void 0 || onVisible(isVisible);
  }, [isVisible]);
  return /*#__PURE__*/React.createElement(Tag, _extends({
    "aria-label": title,
    className: cnQuickButton(null, [className]),
    form: "round",
    ref: combineRefs([buttonRef, ref]),
    role: "tab"
  }, params), Icon && /*#__PURE__*/React.createElement(Icon, {
    className: cnQuickButton('icon-btn'),
    color: "primary-invert",
    size: "xs"
  }), /*#__PURE__*/React.createElement(Text, {
    className: cnQuickButton('text'),
    color: "primary-invert",
    truncate: true,
    variant: "body-small"
  }, title));
});